import { Divider } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Slider from "@material-ui/core/Slider";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React, { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IP } from "../../../config/IP";
import { updateOrder } from "../../services/order/actions";
const useStyles = makeStyles((theme) => ({
	root: {
		width: 300,
	},
	input: {
		width: 42,
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		width: "100%",
	},
	list: {
		width: "100%",
	},
	divlist: { width: "100%", paddingLeft: 10 },
	listItem: { padding: 50 },
	ListItemText: { marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
	Slider: { width: "20%", marginRight: theme.spacing(1) },

	fullList: {
		width: "100%",
	},
}));

function CartAdjust(props, ref) {
	const [open, setOpen] = React.useState(false);
	const state = useSelector((state) => state);
	const dispatch = useDispatch();
	const [value, setValue] = React.useState(30);
	const theme = useTheme();
	const [fullWidth, setFullWidth] = React.useState(true);
	const [maxWidth, setMaxWidth] = React.useState("md");
	const fullScreen = useMediaQuery(theme.breakpoints.down("lg"));
	const [newItems, setNewItems] = React.useState(
		state.order.order.items.map((product) => ({
			...product,
			newQuantity:
				props.error.filter(
					(x) =>
						x.sku === product.sku &&
						x.companyId === product.companyId &&
						x.siteId === product.siteId
				).length > 0
					? props.error.find(
							(x) =>
								x.sku === product.sku &&
								x.companyId === product.companyId &&
								x.siteId === product.siteId
					  ).remainingStock
					: 0,
		}))
	);

	const handleSliderChange = (event, newValue, product, index) => {
		console.log("handleSliderChange product=", product);
		console.log("handleSliderChange index=", index);
		console.log("handleSliderChange newValue=", newValue);
		setValue(newValue);

		let newItemsTemp = newItems;
		newItemsTemp[index].newQuantity = newValue;
		console.log("newItemsTemp=", newItemsTemp);
		setNewItems(newItemsTemp);
		setNewOrder({
			...newOrder,
			items: newItemsTemp,
			totalCost: newItemsTemp.reduce(
				(k, v) =>
					k +
					(v.newQuantity
						? v.newQuantity > 0
							? v.newQuantity * v.price
							: 0 * v.price
						: v.quantity * v.price),
				0
			),
		});
	};

	const [newOrder, setNewOrder] = React.useState({
		...state.order.order,
		items: newItems,
		totalCost: newItems.reduce(
			(k, v) =>
				k +
				(v.newQuantity
					? v.newQuantity > 0
						? v.newQuantity
						: 0 * v.price
					: v.quantity * v.price),
			0
		),
	});

	const handleInputChange = (event) => {
		setValue(event.target.value === "" ? "" : Number(event.target.value));
	};

	const handleBlur = () => {
		if (value < 0) {
			setValue(0);
		} else if (value > 100) {
			setValue(100);
		}
	};
	const classes = useStyles();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const handleAdjust = () => {
		let neworderValue = {
			...newOrder,
			items: newOrder.items.map((x) => ({
				...x,
				quantity: x.newQuantity > 0 ? x.newQuantity : x.quantity,
			})),
		};

		console.log("CartAdjust handleAdjust newOrder=", neworderValue);
		let inputs = {
			url: IP.nodeServer + "api/createOrder",
			method: "POST",
			data: {
				action: "adjust_request",
				totalCost: neworderValue.totalCost,
				items: neworderValue.items.filter((x) => x.newQuantity >= 0),
				orderId: neworderValue._id,
				isAuthenticated: false,
			},
		};
		console.log("updateOrder inputs=", inputs);
		dispatch(updateOrder(inputs));
	};

	useImperativeHandle(ref, () => ({
		Open: handleClickOpen,
		Close: handleClose,
		Adjust: handleAdjust,
	}));
	console.log("cartAdjust props.error=", props.error);
	console.log("cartAdjust  state.order.order.items=", state.order.order.items);
	console.log("newItems=", newItems);

	React.useEffect(() => {
		console.log("useEffect newItems=", newItems);
	}, [newItems, setNewItems]);
	React.useEffect(() => {
		console.log("newOrder=", newOrder);
	}, [newOrder, setNewOrder]);

	return (
		<div className={classes.root}>
			<Dialog
				open={open}
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
				onClose={handleClose}
			>
				<DialogTitle id="form-dialog-title">Cart Adjustment</DialogTitle>
				<DialogContent id="responsive-dialog-title" className={classes.divlist}>
					<DialogContentText>
						To Update the cart please adjust the quantity.
					</DialogContentText>
					<Box alignItems="center">
						<List className={classes.list}>
							{newItems.map((product, index) => (
								<ListItem className={classes.listItem} key={product.sku}>
									<ListItemText
										primary={
											props.error.filter(
												(x) =>
													x.sku === product.sku &&
													x.companyId === product.companyId &&
													x.siteId === product.siteId
											).length > 0 ? (
												props.error.find(
													(x) =>
														x.sku === product.sku &&
														x.companyId === product.companyId &&
														x.siteId === product.siteId
												).remainingStock <= 0 ? (
													<del>{product.title}</del>
												) : (
													product.title
												)
											) : (
												product.title
											)
										}
										secondary={
											props.error.filter(
												(x) =>
													x.sku === product.sku &&
													x.companyId === product.companyId &&
													x.siteId === product.siteId
											).length > 0 ? (
												props.error.find(
													(x) =>
														x.sku === product.sku &&
														x.companyId === product.companyId &&
														x.siteId === product.siteId
												).remainingStock <= 0 ? (
													<del>{product.style}</del>
												) : (
													product.style
												)
											) : (
												product.style
											)
										}
										className={classes.ListItemText}
									/>
									<ListItemText
										className={classes.ListItemText}
										primary="Quantity:"
										secondary={
											!props.error.filter(
												(x) =>
													x.sku === product.sku &&
													x.companyId === product.companyId &&
													x.siteId === product.siteId
											).length > 0 ? (
												product.quantity
											) : (
												<>
													{props.error.find(
														(x) =>
															x.sku === product.sku &&
															x.companyId === product.companyId &&
															x.siteId === product.siteId
													).remainingStock > 0 ? (
														<>
															<div>
																<del>{product.quantity}</del>
															</div>
															<TextField
																disabled
																label="New"
																id="standard-size-small"
																defaultValue={
																	props.error.find(
																		(x) =>
																			x.sku === product.sku &&
																			x.companyId === product.companyId &&
																			x.siteId === product.siteId
																	).remainingStock
																}
																value={product.newQuantity}
																size="small"
															/>
														</>
													) : (
														"Product out of Stock in this SITE!"
													)}
												</>
											)
										}
									/>
									{props.error.filter(
										(x) =>
											x.sku === product.sku &&
											x.companyId === product.companyId &&
											x.siteId === product.siteId
									).length > 0 ? (
										<>
											{props.error.find(
												(x) =>
													x.sku === product.sku &&
													x.companyId === product.companyId &&
													x.siteId === product.siteId
											).remainingStock > 0 ? (
												<Slider
													className={classes.Slider}
													aria-labelledby="discrete-slider"
													valueLabelDisplay="auto"
													step={1}
													marks
													min={1}
													max={
														props.error.find(
															(x) =>
																x.sku === product.sku &&
																x.companyId === product.companyId &&
																x.siteId === product.siteId
														).remainingStock
													}
													value={
														typeof product.newQuantity === "number"
															? product.newQuantity
															: 0
													}
													onChange={(event, newvalue) =>
														handleSliderChange(event, newvalue, product, index)
													}
													aria-labelledby="input-slider"
												/>
											) : (
												""
											)}
										</>
									) : (
										<Slider
											disabled
											className={classes.Slider}
											aria-labelledby="discrete-slider"
											valueLabelDisplay="auto"
											defaultValue={product.quantity}
											step={1}
											min={1}
											max={product.quantity}
											marks
											value={product.quantity}
											aria-labelledby="input-slider"
										/>
									)}

									<Typography variant="body2">
										{props.error.filter(
											(x) =>
												x.sku === product.sku &&
												x.companyId === product.companyId &&
												x.siteId === product.siteId
										).length > 0 ? (
											props.error.find(
												(x) =>
													x.sku === product.sku &&
													x.companyId === product.companyId &&
													x.siteId === product.siteId
											).remainingStock <= 0 ? (
												<del>
													{product.currencyId +
														"" +
														new Intl.NumberFormat().format(product.price)}
												</del>
											) : (
												product.currencyId +
												"" +
												new Intl.NumberFormat().format(product.price)
											)
										) : (
											product.currencyId +
											"" +
											new Intl.NumberFormat().format(product.price)
										)}
									</Typography>
									<Divider />
								</ListItem>
							))}
							<ListItem className={classes.listItem}>
								<ListItemText primary="Total" />
								<Typography variant="subtitle1" className={classes.total}>
									{newOrder.currencyId +
										"" +
										Intl.NumberFormat().format(newOrder.totalCost)}
								</Typography>
							</ListItem>
						</List>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					{newOrder.totalCost > 0 ? (
						<Button onClick={props.handleAdjust} color="primary">
							Adjust
						</Button>
					) : (
						""
					)}
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default forwardRef(CartAdjust);
